import { ChatConversation } from '../../domain/models/chat-conversation.model';
import { ConversationSummary } from '../../domain/models/conversation-summary.model';
import { QuickQuestion } from '../../domain/models/quick-question.model';

export interface ConversationState {
  readonly activeConversation: ChatConversation | null;
  readonly conversationHistory: readonly ConversationSummary[];
  readonly savedConversations: readonly ConversationSummary[];
  readonly selectedConversationId: string | null;
  readonly quickQuestions: readonly QuickQuestion[];
  readonly loading: boolean;
  readonly sendingMessage: boolean;
  readonly error: string | null;
}

export function createInitialConversationState(): ConversationState {
  return {
    activeConversation: null,
    conversationHistory: [],
    savedConversations: [],
    selectedConversationId: null,
    quickQuestions: [],
    loading: false,
    sendingMessage: false,
    error: null,
  };
}

export const initialConversationState: ConversationState = createInitialConversationState();
